module.exports = __webpack_public_path__ + "assets/img/sdwan-module1-6.5a0aefe7.png";